// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__14oc6","bigColWidth":"Table_bigColWidth__fuczh","biggerColWidth":"Table_biggerColWidth__-7qzW","row":"Table_row__26rbf","col":"Table_col__t3bof"};